export const ICONS = {
  MODE: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
  STATUS:
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
  DRIVER:
    'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  DEVICE:
    'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zM9.5 8.5H12V7H8v4h1.5V8.5zM12 17h4v-4h-1.5v2.5H12V17z',
  ADDRESS:
    'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
  // Иконка молотка без кружка
  MODE_HAMMER:
    'M18 2h-2v2h-2v2h2v2h2V6h2V4h-2V2zM6 2H4v2h2v2H4v2h2V6h2V4H6V2zm10 4h-2v2h2V6zm-2 4V8h2v2h-2zm-8 2h2v-2H6v2zm0 0v2H4v-2h2zm6 0h-2v2h2v-2zm-4 2v2h2v-2H8zm8 0h-2v2h2v-2zm0 0h2v2h-2v-2zm-12 2h2v2H4v-2zm14 2h-2v2h2v-2zm-6 2v2h2v-2h-2zm-4 0h2v2H8v-2z',
  // Альтернативная иконка молотка (более простая)
  MODE_HAMMER_SIMPLE:
    'M18 2h-2v2h-2v2h2v2h2V6h2V4h-2V2zM6 2H4v2h2v2H4v2h2V6h2V4H6V2zm10 4h-2v2h2V6zm-2 4V8h2v2h-2zm-8 2h2v-2H6v2zm0 0v2H4v-2h2zm6 0h-2v2h2v-2zm-4 2v2h2v-2H8zm8 0h-2v2h2v-2zm0 0h2v2h-2v-2zm-12 2h2v2H4v-2zm14 2h-2v2h2v-2zm-6 2v2h2v-2h-2zm-4 0h2v2H8v-2z',
};
